// src/pages/CourseTime/components/slides/layouts/ContentSinglePointWithImageSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layout: content_single_point_with_1_image
const ContentSinglePointWithImageSlide = ({ slide, renderSpokenText, skipTitleSpeech }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  return (
    <S.SlideSinglePointWithImage>
      <S.SlidePoints>
        {Array.isArray(slide.SlideContent) && slide.SlideContent.map((point, idx) => (
            <S.SlidePoint key={idx}>
              {typeof point === 'string' ? (
                  <S.PointText>{renderContent(`content_${idx}`, point)}</S.PointText>
              ) : (
                  <>
                    {point.PointTitle && <S.PointTitle>{renderContent(`content_${idx}_title`, point.PointTitle)}</S.PointTitle>}
                    {point.PointText  && <S.PointText>{renderContent(`content_${idx}_text`,  point.PointText)}</S.PointText>}
                  </>
              )}
            </S.SlidePoint>
        ))}
        {typeof slide.SlideContent === 'string' && (
            <S.SlidePoint>
              <S.PointText>{renderContent('content_0', slide.SlideContent)}</S.PointText>
            </S.SlidePoint>
        )}
      </S.SlidePoints>
      {slide.Images && slide.Images.length > 0 && (
        <S.SlideLargeImageContainer>
          <S.SlideLargeImage
            src={typeof slide.Images[0] === 'string' ? slide.Images[0] : slide.Images[0].url || ''}
            alt={`Slide ${slide.SlideOrder} image`}
          />
        </S.SlideLargeImageContainer>
      )}
    </S.SlideSinglePointWithImage>
  );
};

export default ContentSinglePointWithImageSlide;
